import React, { Component } from 'react';
import Shimmer from 'sushiweb/Shimmer';
import { nonLogsBgImg } from '../../../images/images';

import './TakeAwayOrder.scss';

export default class TakeAwayOrder extends Component {
  shouldComponentUpdate(nextProps) {
    if (this.props.order === nextProps.order) {
      return false;
    } else {
      return true;
    }
  }
  render() {
    const { order } = this.props;
    return (
      <div className='takeAwayOrderBox'>
        {!order ? (
          <Shimmer height='100%' width='100%' />
        ) : (
          <TakeAwayOrderComp {...this.props} />
        )}
      </div>
    );
  }
}

class TakeAwayOrderComp extends React.Component {
  render() {
    const { order } = this.props;
    if (!order || !order.order) return null;
    let nonLogsBackgroundImg = {
      backgroundImage: `url(${nonLogsBgImg})`,
      backgroundSize: 'cover',
    };
    const { takeaway_order_detials } = order.order;
    if (!takeaway_order_detials) return null;

    return (
      <div className='takeAwayOrder'>
        <p className='lighter'>
          <span role='img' aria-label='bike'>
            🙋‍♂️
          </span>
          Self Pickup order
        </p>
        <div className='takeAwayOrderContent' style={nonLogsBackgroundImg}>
          <div className='riderImage'>
            <img src={takeaway_order_detials.image_url} alt='' />
          </div>
          <p className='deliveryTime small'>{takeaway_order_detials.text}</p>
        </div>
      </div>
    );
  }
}
